import styled from "@emotion/styled";
import { colors, fontFamily, hvCenter, media, pxtorem } from "../../../assets/styles/theme";
import  managePlatformBottomBg from "../../../assets/images/managePlatformBottomBg.svg";

export const CredentialConfigWrapper = styled('div')`
  padding: 0 20px 0 20px;
  background: ${colors.white};
  border-radius:12px;
  margin-bottom: 25px;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 190px;
    height: 190px;
    right: -40px;
    top: 85%;
    z-index: -1;
    background-image: url(${managePlatformBottomBg});
    background-position: 0 0;
    background-repeat: no-repeat;   
    background-size: contain;     
    ${media.lg`   
        right: -20px;
    `} 
  } 

  .count-wrapper{
    width: 35px;
    min-width: 35px;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .adsFileUploadWrapper {
    width: 100%;
    overflow: hidden;
    position: relative;
    .MuiInputBase-input {
      margin-left: 0;
      position: absolute;
      opacity: 0;
      padding-top: 5px;
      width: calc(100% - 135px);
      height: 12px;
      visibility:hidden;
      cursor: pointer;
      ${media.xxxl`
        margin-left: -132px; 
      `}   
      &.Mui-disabled{
        visibility: hidden;
      }   
    }
    .Mui-disabled {
      .MuiTypography-root, .labelJsonFileName  {
        color: ${colors.secondaryText};
        cursor: default;
      }
      .MuiInputAdornment-root svg path {
        color: ${colors.secondaryText};
      }     
    }
    .MuiInputAdornment-positionStart {
      position: relative; 
      width: 100%;
      svg {
        z-index: 99;
        margin-left: -4px;
      }      
    }
    .linkWrapper {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 15px;
      top: 11px;
      a {
        text-decoration: none;
        &:hover{
          text-decoration: underline ;
        }
      }
      ${media.md`
        margin-top: 29px;
        margin-right: -13px;
        z-index: 99;
        position: absolute;
      `}
    }
    .labelJsonFileName {
      overflow: hidden;
      width: calc(100% - 85px);
      text-overflow: ellipsis; 
      position: absolute;
      left: -12px;
      top: -17px;    
      padding: 7px 0 5px 30px;
      height: 34px;
      z-index: 99; 
      cursor: pointer;
      font-size: ${pxtorem(13)};
      font-family: ${fontFamily.karla};
      font-weight: 400;
      line-height: 1.4;
      color: ${colors.primaryText}
    }
  }
  .borderSeprator {
    padding-left: 60px;
    padding-right: 40px;
  }
  .MuiAccordionDetails-root form:last-child .borderSeprator{
    display: none;
  }
  .cc-action-wrapper {
    padding-top: 25px;
    margin-top: -50px;
    background: ${colors.white};
    z-index: 97;
    position: relative;
  }

  .connection-loader{
    position: absolute;
    top: 70px;
    left: 0;
    bottom: 40px;
    right: 0;
    background: ${colors.darkestWhite};
    z-index: 99;
    ${hvCenter};
  }
`;